export type SolutionsDataModel = {
  linkTo?: string;
  title: Array<string>;
  imgSrc: string;
  imgAlt: string;
};

export const SOLUTIONS_DATA: Array<SolutionsDataModel> = [
  {
    imgSrc: "/static/img/solutions/green-energy.png",
    imgAlt: "Um painel solar com uma avaliação positiva",
    title: ["Contratar", "energia verde"],
    linkTo: "/solutions/green-energy-contracts",
  },
  {
    linkTo: "/solutions/automate-ac",
    imgSrc: "/static/img/solutions/automate-ac.png",
    imgAlt:
      "Um aparelho de ar condicionado sendo controlado por aplicativo em um telefone celular",
    title: ["Automatizar", "ar-condicionado"],
  },
  {
    linkTo: "/solutions/automate-consumer-monitoring",
    imgSrc: "/static/img/solutions/consumption.png",
    imgAlt: "Um medidor inteligente de energia",
    title: ["Monitorar", "o consumo de energia"],
  },
  {
    linkTo: "/solutions/prosumer-credentials",
    imgSrc: "/static/img/solutions/fotovoltaico.png",
    imgAlt:
      "Uma casa com painel solar no telhado ao lado de um aplicativo de celular mostrando dados sobre o painel",
    title: ["Monitorar o", "meu sistema solar"],
  },
  {
    linkTo: "/frames/simulator",
    imgSrc: "/static/img/solutions/simulator-panel.png",
    imgAlt: "Uma lâmpada e uma calculadora lado a lado",
    title: ["Simular minha", "economia de energia"],
  },
  {
    linkTo: "/solutions/diagnosis",
    imgSrc: "/static/img/solutions/unsure.png",
    imgAlt:
      "Um poste com várias placas um com ponto de interrogação, cada uma apontando em uma direção",
    title: ["Encontrar as", "melhores soluções"],
  },
];
